import {ChangeDetectionStrategy, Component} from '@angular/core';
import {RequestStatusEnum} from '@dto/requests/request-status.enum';
import {RequestListComponent} from '../request-list/request-list.component';

@Component({
    selector: 'app-completed-requests',
    templateUrl: './completed-requests.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RequestListComponent]
})
export class CompletedRequestsComponent {
  requestStatus = RequestStatusEnum.Completed;
  noRequestsMessage = 'No requests completed';
}
